import { render, staticRenderFns } from "./seal.vue?vue&type=template&id=4c04ae37&scoped=true&"
import script from "./seal.vue?vue&type=script&lang=js&"
export * from "./seal.vue?vue&type=script&lang=js&"
import style0 from "./seal.vue?vue&type=style&index=0&id=4c04ae37&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c04ae37",
  null
  
)

export default component.exports